import { Lock, Gavel, FileCheck2 } from "lucide-react";

// Compact Custody / Authority / Evidence explainer shown at each stage.
export function CaropsBox({ carops, stage }) {
  const c = carops?.[stage];
  if (!c) return null;
  const rows = [
    { icon: Lock, label: "Custody", text: c.custody, tone: "text-mill-moss" },
    { icon: Gavel, label: "Authority", text: c.authority, tone: "text-katlas-blue" },
    { icon: FileCheck2, label: "Evidence", text: c.evidence, tone: "text-[#B45309]" },
  ];
  return (
    <div className="grid grid-cols-1 gap-3 rounded-2xl border border-stone-200 bg-mill-alt/40 p-4 sm:grid-cols-3" data-testid={`carops-${stage}`}>
      {rows.map((r) => (
        <div key={r.label}>
          <p className={`flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] ${r.tone}`}>
            <r.icon className="h-3.5 w-3.5" /> {r.label}
          </p>
          <p className="mt-1 text-xs leading-relaxed text-mill-muted">{r.text}</p>
        </div>
      ))}
    </div>
  );
}
